import React from 'react';
import styles from '../styles/CategorySkeleton.module.css';

export const CategorySkeleton = () => {
  return (
    <div className={styles.categorySection}>
      <div className={styles.categoryContainer}>
        {[...Array(8)].map((_, index) => (
          <div key={index} className={styles.categoryButton} />
        ))}
      </div>
    </div>
  );
};
